import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostCategories(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostCategories,
      parentId,
      masterBlockId,
    ),
    fontSize: 12,
    color: 'rgba(0, 116, 199, 1)',
    mobileFontSize: 12,
    alignSelf: 'left',
  } as BlogPostCategoriesInterface
}
